module.exports = __webpack_public_path__ + "static/media/tick.f5ced685.svg";